import { render, staticRenderFns } from "./plug-adtype-list.vue?vue&type=template&id=0df7d3b5&scoped=true&"
import script from "./plug-adtype-list.vue?vue&type=script&lang=js&"
export * from "./plug-adtype-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df7d3b5",
  null
  
)

export default component.exports